import { InvestmentAccountType } from '@egw/api'
import { Link } from '@egw/components'
import { configClient } from '@egw/config'
import { Trans, useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { type Config } from '../../config/config'
import { useTransferContextProvider } from '../../context'
import { ETransferType } from '../../types'
import { checkIfBankAccountPosition, checkIfInvestmentAccountPosition } from '../../utils'

export const TransferTermsAndConditions: FC = () => {
  const config = configClient.getConfig() as Config
  const { fromFieldOption, toFieldOption, transferType } = useTransferContextProvider()
  const { t } = useTranslation('features-transfer')

  const hideTermsAndConditions = transferType === ETransferType.NA

  const showAchTermsAndConditions = transferType === ETransferType.ACH

  const isBankInvestmentTransfer = transferType === ETransferType.BankInvestment

  // If Bank | Invesment Transfer and From Position is an Traditional IRA || Roth IRA than it is an IRA Withdrawal
  const isIRAWithdrawal =
    transferType === ETransferType.BankInvestment &&
    (fromFieldOption.accountType === InvestmentAccountType.TRADITIONAL_IRA ||
      fromFieldOption.accountType === InvestmentAccountType.ROTH_IRA)

  const isIRADeposit =
    transferType === ETransferType.BankInvestment &&
    (toFieldOption.accountType === InvestmentAccountType.TRADITIONAL_IRA ||
      toFieldOption.accountType === InvestmentAccountType.ROTH_IRA)

  // If Bank | Invesment Transfer and From Position is an Investment Account than it is going to Bank Account
  const isToBankTransfer =
    isBankInvestmentTransfer && checkIfInvestmentAccountPosition(fromFieldOption) && !isIRAWithdrawal && !isIRADeposit

  // If Bank | Invesment Transfer and From Position is an Bank Account than it is going to Investment Account
  const isToInvestmentTransfer =
    isBankInvestmentTransfer && checkIfBankAccountPosition(fromFieldOption) && !isIRAWithdrawal && !isIRADeposit

  if (hideTermsAndConditions) return null

  return (
    <p className="block w-full typo-primary-sm-regular max-md:text-center mt-2 text-text-meta">
      {showAchTermsAndConditions ? (
        <Trans t={t} i18nKey="transfer.transfer_terms_and_conditions">
          <Link
            href={config.zendeskArticles.achAuthorization}
            className="hyperlink-muted underline inline-flex typo-primary-sm-regular text-text-body hover:text-text-body"
          />
        </Trans>
      ) : null}
      {isToInvestmentTransfer ? <Trans t={t} i18nKey="transfer.to_investment_from_bank_terms_and_conditions" /> : null}
      {isToBankTransfer ? <Trans t={t} i18nKey="transfer.to_bank_from_investment_terms_and_conditions" /> : null}
      {isIRAWithdrawal ? (
        <Trans t={t} i18nKey="transfer.ira_withrdrawal_terms_and_conditions">
          <Link
            href={config.zendeskArticles.achAuthorization}
            className="hyperlink-muted underline inline-flex typo-primary-sm-regular text-text-body hover:text-text-body"
          />
        </Trans>
      ) : null}
      {isIRADeposit ? (
        <Trans t={t} i18nKey="transfer.ira_deposit_terms_and_conditions">
          <Link
            href={config.zendeskArticles.achAuthorization}
            className="hyperlink-muted underline inline-flex typo-primary-sm-regular text-text-body hover:text-text-body"
          />
        </Trans>
      ) : null}
    </p>
  )
}
